import React, { useEffect, useRef, useState } from 'react'

//Utils
import { getEventColor } from "Components/Map/utils";
import { getVidFleetEvent } from 'Core/data/VideoEvents';
import { getIconAttributes } from 'Modules/incidents/views/overview/components/historyOverView/utils'
import { MarkerCompat } from '../../providers/markerCompat';
const SimpleMap = ({ data, zoom, height }) => {

    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const markerRef = useRef(null);

    const validateEventColor = (item) => {
        let eventName = '';
        if (item && item['eventName']) {
            eventName = item['eventName'].toString();
        }

        if (item && item['event'] && eventName == '') {
            eventName = item['event'].toString();
        }
        return getEventColor(eventName);
    }

    useEffect(() => {
        if (!google) {
            return;
        }

        if (!map) {
            const mapOptions = {
                zoom: 4,
                center: { lat: 37.0902, lng: -95.7129 },
                mapTypeControl: false,
            };

            const newMap = new google.maps.Map(mapRef.current, mapOptions);
            setMap(newMap);
        } else {
            if (data?.coords && data.coords?.lat && data.coords?.lng) {
                map.setCenter(data?.coords);
                map.setZoom(zoom || 10);

                if (markerRef.current) {
                    markerRef.current.setMap(null);
                }

                const color = validateEventColor(data);

                let url = null;
                let imageStyle = {};

                if (data?.eventCode && (data?.eventCode?.includes("CameraEvent") || data?.eventCode?.includes("GpsData.Moving"))) {
                    let event = getVidFleetEvent(data?.eventCode);
                    url = event.icon;
                    imageStyle = {
                        anchor: new google.maps.Point(15, 10)  // eslint-disable-line no-undef
                    };
                }
                const iconMarker = getIconAttributes(color, data.heading, url, imageStyle, data)
                const newMarker = new MarkerCompat({
                    position: data?.coords,
                    map: map,
                    icon: iconMarker,
                    info: data,
                });
                markerRef.current = newMarker;
            }
        }
    }, [data, zoom, map]);

    return <div style={{ width: '100%', height: height || '400px' }} ref={mapRef}></div>;

}

export default SimpleMap